var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimePast1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "time-past_1_",
    "data-name": "time-past (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.488,
    height: 14.488,
    viewBox: "0 0 14.488 14.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15560",
    "data-name": "Path 15560",
    d: "M7.244,0A7.227,7.227,0,0,0,2.415,1.855V.6A.6.6,0,1,0,1.207.6V2.415A1.811,1.811,0,0,0,3.018,4.226H4.829a.6.6,0,0,0,0-1.207H3.018a.516.516,0,0,1-.06-.013A6.029,6.029,0,1,1,1.207,7.244.6.6,0,0,0,0,7.244,7.244,7.244,0,1,0,7.244,0Z",
    transform: "translate(0 0)",
    fill: "#23bee3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15561",
    "data-name": "Path 15561",
    d: "M11.6,6a.6.6,0,0,0-.6.6V9.622a.6.6,0,0,0,.177.427l1.811,1.811a.6.6,0,1,0,.854-.854L12.207,9.372V6.6A.6.6,0,0,0,11.6,6Z",
    transform: "translate(-4.36 -2.378)",
    fill: "#23bee3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePast1);
export default __webpack_public_path__ + "static/media/time-past (1).227a360ef6818a05059f1cdd0650e326.svg";
export { ForwardRef as ReactComponent };